import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button } from '../../../components/UI/ComponentsUI';
import ConfirmModal from '../../../components/UI/ConfirmModal';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { ENUMS } from '../../../utils/constants';
import { configs, showMessageToast, translate } from '../../../utils/util';

const FinalizeConfirmation = (props) => {
    const [configState, setConfig] = useState({});

    useEffect(() => {
        setConfig(configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items));
        // eslint-disable-next-line
    }, []);

    const submit = () => {
        if (!isConfirmationsValid()) {
            return;
        }

        if (props.physicalConfirmationList && props.physicalConfirmationList.length > 0) {
            const unique = [...new Set(props.physicalConfirmationList.map(item => item.id))];
            unique.forEach(id => {
                props.finalizarConferencia({
                    physicalConfirmationId: id,
                    justificationId: '',
                    shed: props.user.shed,
                    user: '',
                    vasilhames: props.vasilhames
                });
            });
        }
        else {
            props.finalizarConferencia({
                physicalConfirmationId: props.physicalConfirmation.id,
                justificationId: '',
                shed: props.user.shed,
                user: '',
                vasilhames: props.vasilhames
            });
        }
    }

    const onConfirmModal = () => {
        props.finalizarConferencia({
            physicalConfirmationId: props.physicalConfirmation.id,
            justificationId: '',
            shed: props.user.shed,
            user: '',
            vasilhames: props.vasilhames
        });
    }

    const isConfirmationsValid = () => {
        if ((!props.user.shed || props.user.shed === '') && Boolean(configState.shedRequiredPhysicalConfirmation)) {
            showMessageToast({ html: translate('select-shed', 'validations'), classes: 'red' });
            return false;
        }

        if ((!props.user.dock || props.user.dock === '') && Boolean(configState.dockRequiredPhysicalConfirmation)) {
            showMessageToast({ html: translate('select-dock', 'validations'), classes: 'red' });
            return false;
        }

        return true;
    }

    return (
        <div>
            <div className="container-fluid h-65" />
            <div className="container">
                <div className="row">
                    <Button full="true" onClick={submit.bind(this)} text={translate('finalize', 'physical-confirmation')} icon="check_circle" />

                </div>
            </div>
            <ConfirmModal
                id="deemconfirmed"
                data={{ title: translate("physical-confirmation:atention-deem"), message: translate("physical-confirmation:deem-minor-confirmation") }}
                onConfirm={onConfirmModal}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
            />
        </div >


    );
}

const mapStateToProps = (state) => {
    return {
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,
        mdrs: state.volumeReducer.packing,
        user: state.userReducer.user,
        config: state.configReducer.config,
        receipts: state.physicalConfirmationReducer.receipts,
        physicalConfirmationList: state.physicalConfirmationReducer.physicalConfirmationList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        finalizarConferencia: (dataFinished, callback) => {
            dispatch(PhysicalConfirmationService.finishPhysicalConfirmation(dataFinished, callback));
        },
        checkPendingItens: (dataFinished, callback) => {
            dispatch(PhysicalConfirmationService.checkPendingItens(dataFinished, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FinalizeConfirmation));
